export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_DRAMA_AND_THEATRE.45be970d.svg";